import Layout from "layout";
import React from "react";
import { MainHeading, PageRoot, StyledBreadCrumbs } from "./styles";
import ProductFrom from "./ProductForm";

const items = [
  {
    title: "Added Product",
  },
  {
    title: "Add New Product",
  },
];

const AddProductPage = () => {
  return (
    <Layout>
      <PageRoot>
        <StyledBreadCrumbs items={items} />
        <MainHeading>{`Add New Product`}</MainHeading>
        <ProductFrom />
      </PageRoot>
    </Layout>
  );
};

export default AddProductPage;
